module.exports = __webpack_public_path__ + "static/media/07_plantilla_combo_rectangular_fondo_6.673e0cdb.jpg";